import { render, staticRenderFns } from "./fontColor.vue?vue&type=template&id=60d9d9ef&scoped=true"
import script from "./fontColor.vue?vue&type=script&lang=js"
export * from "./fontColor.vue?vue&type=script&lang=js"
import style0 from "./fontColor.vue?vue&type=style&index=0&id=60d9d9ef&prod&lang=less"
import style1 from "./fontColor.vue?vue&type=style&index=1&id=60d9d9ef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d9d9ef",
  null
  
)

export default component.exports